import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { MenuList as MenuList$1, MenuItem as MenuItem$1, ListItemIcon } from '@mui/material';
import { styled, css } from '@mui/material/styles';
import { spacing, alpha } from '@mui/system';
import { shouldNotForwardProps, spacing as spacing$1, withUtility } from '../../foundation/utils.js';

let _ = t => t,
  _t,
  _t2;
const MenuList = styled(MenuList$1, {
  shouldForwardProp: shouldNotForwardProps
})(_t || (_t = _`
  ${0};

  padding: ${0};

  & .MuiMenuItem-root {
    min-height: 40px;
    border-radius: 8px;
    padding-left: ${0};
    padding-right: ${0};
  }

  & .MuiDivider-root {
    margin: ${0};
  }

  ${0}
`), spacing, spacing$1(2), spacing$1(2), spacing$1(2), spacing$1(2), withUtility(({
  palette
}) => {
  return css(_t2 || (_t2 = _`
      color: ${0};
      & .MuiMenuItem-root:hover {
        background-color: ${0};
      }
    `), palette('onSurfaceVariant'), alpha(palette('primary'), 0.08));
}));
const MenuItem = props => {
  return jsxs(MenuItem$1, Object.assign({}, props, {
    children: [props.startIcon && jsx(ListItemIcon, {
      children: props.startIcon
    }), props.children, props.endIcon && jsx(ListItemIcon, Object.assign({
      sx: {
        marginLeft: 'auto',
        minWidth: 'auto !important'
      }
    }, {
      children: props.endIcon
    }))]
  }));
};

export { MenuItem, MenuList };
